import { render, staticRenderFns } from "./BtnVoltar.vue?vue&type=template&id=4be8a0b2&"
import script from "./BtnVoltar.vue?vue&type=script&lang=js&"
export * from "./BtnVoltar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports